import React from 'react'
import { Message, toaster } from 'rsuite'
import { ReactComponent as Icon } from '../../../assets/svgs/check.svg'
import { ReactComponent as ErrorIcon } from '../../../assets/svgs/warning.svg'
import './toaster.scss'

interface ShowToastProps {
  message: string
  description?: string
  duration?: number
  icon?: React.ReactNode
  ErrorIcon?: React.ReactNode
  isError?: boolean
  isWarning?: boolean
}

export const showToast = ({
  message = '',
  description = '',
  duration = 3000,
  icon = <Icon />,
  isError,
  isWarning,
}: ShowToastProps) => {
  toaster.push(
    <Message className={`toast-container ${isError ? 'error' : isWarning ? 'warning' : ''} `}>
      {isError ? <ErrorIcon /> : icon}
      <div className="message">
        <span>{message}</span>
        <p>{description}</p>
      </div>
    </Message>,
    {
      duration,
    }
  )
}
